export default "__VITE_ASSET__83f87609__"